import { stringEnum } from 'app/config/utils';
import * as t from 'io-ts';

export enum SignupSource {
  Student = 'Student',
  Teacher = 'Teacher',
}

export const SignupStateParam = t.partial({
  source: stringEnum<SignupSource>(SignupSource, 'SignupSource'),
});

export type ISignupStateParam = t.TypeOf<typeof SignupStateParam>;
